import { facets } from "../facets.js";
import { convertFacet } from "../units-conversion.js";
import { resolveColumnPrecision } from "../number-formatting.js";
import { chamfrRangeSlider, chamfrRefinementList } from "../widgets/index.js";

// Helper function to generate label HTML with optional tooltip
const generateLabelHTML = (label, tooltip) => {
  if (!tooltip) {
    return `<p>${label}</p>`;
  }

  // return `<p>${label} <span class="tooltip-icon" title="${tooltip}">?</span></p>`;
  return `<p>${label}</p>`;
};

export const renderFilters = (filters, container, productCategoryElement) => {
  container.innerHTML = "";

  const widgets = [];

  filters.forEach((f) => {
    if (!facets[f.key]) {
      return;
    }
    const filter = convertFacet(facets[f.key]);

    const filterElement = document.createElement("div");
    filterElement.classList.add("filter-box");

	if (f.hide || f.adminOnly) {
      filterElement.classList.add("admin-only");
    }

    switch (filter.type) {
      case "rangeSlider":
        filterElement.innerHTML = `<div class="filter-box-heading">
					${generateLabelHTML(filter.label, filter.tooltip)}
				</div>
				<div class="filter-box-content slider-wrapper">
					<div class="chamfr-products-${f.key} slider-container"></div>
				</div>`;
        container.appendChild(filterElement);

        widgets.push(
          chamfrRangeSlider({
            container: productCategoryElement.querySelector(
              `.chamfr-products-${f.key}`
            ),
            attribute: filter.attribute,
            precision: resolveColumnPrecision(filter, f),
          })
        );
        break;

      case "refinementList":
      default:
        filterElement.innerHTML = `<div class="filter-box-heading">
					${generateLabelHTML(filter.label, filter.tooltip)}
				</div>
				<div class="chamfr-products-${f.key}"></div>`;
        container.appendChild(filterElement);

        widgets.push(
          chamfrRefinementList({
            container: productCategoryElement.querySelector(
              `.chamfr-products-${f.key}`
            ),
            attribute: filter.attribute,
            limit: 10,
            showMore: true,
            showMoreLimit: 100,
          })
        );
        break;
    }
  });

  // Insert vendor banners after filters
  const banners = document.getElementById("vendor-left-banners-wrapper");
  if (banners && container) {
    container.insertAdjacentElement("beforeend", banners);
    banners.style.display = "block";
  }

  return widgets;
};
